// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1HjDY","maxWidthContainer":"styles_maxWidthContainer__DDb2U","overlay":"styles_overlay__e1Tfg","text":"styles_text__VDLlA","form":"styles_form__T28sk"};